import { render, staticRenderFns } from "./analysisLogisticsModal.vue?vue&type=template&id=36ec58ab&scoped=true&"
import script from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
export * from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./analysisLogisticsModal.vue?vue&type=style&index=0&id=36ec58ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec58ab",
  null
  
)

export default component.exports